import { styled } from 'styled-components';
import {
  Button,
  CrossMd,
  Text,
  boxShadow,
  mediaHelper,
  paletteHelper,
  spacingHelper,
  radiusHelper,
} from '@property.com.au/ui-kit';

import pcaChatTooltipImage from '../../../../../assets/pca-chat/pca-chat-tooltip.jpg';
import { CompareButton } from '../CompareButton/CompareButton';
import { usePcaChatModalContext } from '../../contexts/PcaChatModalContext';
import { useUserInteractionWithPcaChat } from '../../helpers/useUserInteractionWithPcaChat';

const PcaChatTooltipWrapper = styled.div`
  padding: ${spacingHelper('large')};
  position: fixed;
  z-index: 2;
  background-color: ${paletteHelper('backgroundPrimary')};
  border-radius: ${radiusHelper('large')};
  right: 50%;
  bottom: ${spacingHelper('medium')};
  transform: translateX(50%);
  width: calc(100% - 2 * ${spacingHelper('medium')});

  ${boxShadow.modalBoxShadow};
  ${mediaHelper('tabletMin')} {
    right: ${spacingHelper('medium')};
    width: 360px;
    transform: none;
  }
`;
const TooltipText = styled(Text)``;
const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 120px;
  margin-top: ${spacingHelper('medium')};
`;
const TooltipImage = styled.img`
  width: 100%;
  height: auto;
`;
const StyledCompareButton = styled(CompareButton)`
  width: 100%;
  margin-top: ${spacingHelper('medium')};
`;

const CloseChatModal = styled(Button)`
  position: absolute;
  top: ${spacingHelper('medium')};
  right: ${spacingHelper('medium')};
  z-index: 1;
`;

export const PcaChatTooltip = () => {
  const { setPcaChatModalState } = usePcaChatModalContext();
  const { setUserInteracted } = useUserInteractionWithPcaChat();

  return (
    <PcaChatTooltipWrapper>
      <CloseChatModal
        sizeVariant="small"
        variant="naked"
        hideLabel
        compact
        icon={<CrossMd />}
        onClick={() => {
          setPcaChatModalState(null);
          setUserInteracted();
        }}
      />
      <TooltipText variant="subtitle02">Would you like to compare properties?</TooltipText>
      <ImageWrapper>
        <TooltipImage src={pcaChatTooltipImage} alt="AI Chat Tooltip Placeholder" />
      </ImageWrapper>
      <StyledCompareButton />
    </PcaChatTooltipWrapper>
  );
};
